import api from './api';

const seatMapService = {
  // ── Public ────────────────────────────────────────────────────────────────
  getEventSeatMap: (eventId) =>
    api.get(`/events/${eventId}/seat-map`),

  holdSeats: (eventId, data) =>
    api.post(`/events/${eventId}/seat-map/hold`, data),

  releaseSeats: (eventId) =>
    api.delete(`/events/${eventId}/seat-map/hold`),

  // ── Organizer (seat map CRUD) ─────────────────────────────────────────────
  getMap: (eventId) =>
    api.get(`/organizer/events/${eventId}/seat-map`),

  createMap: (eventId, data) =>
    api.post(`/organizer/events/${eventId}/seat-map`, data),

  updateMap: (eventId, data) =>
    api.put(`/organizer/events/${eventId}/seat-map`, data),

  deleteMap: (eventId) =>
    api.delete(`/organizer/events/${eventId}/seat-map`),

  uploadBackground: (eventId, file) => {
    const form = new FormData();
    form.append('image', file);
    return api.post(`/organizer/events/${eventId}/seat-map/background`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  saveLayout: (eventId, sections) =>
    api.post(`/organizer/events/${eventId}/seat-map/layout`, { sections }),

  // ── Sections ──────────────────────────────────────────────────────────────
  createSection: (eventId, data) =>
    api.post(`/organizer/events/${eventId}/seat-map/sections`, data),

  updateSection: (eventId, sectionId, data) =>
    api.put(`/organizer/events/${eventId}/seat-map/sections/${sectionId}`, data),

  deleteSection: (eventId, sectionId) =>
    api.delete(`/organizer/events/${eventId}/seat-map/sections/${sectionId}`),

  // ── Seats ─────────────────────────────────────────────────────────────────
  getSectionSeats: (eventId, sectionId) =>
    api.get(`/organizer/events/${eventId}/seat-map/sections/${sectionId}/seats`),

  createSeat: (eventId, sectionId, data) =>
    api.post(`/organizer/events/${eventId}/seat-map/sections/${sectionId}/seats`, data),

  generateSeats: (eventId, sectionId, data) =>
    api.post(`/organizer/events/${eventId}/seat-map/sections/${sectionId}/seats/generate`, data),

  updateSeat: (eventId, sectionId, seatId, data) =>
    api.put(`/organizer/events/${eventId}/seat-map/sections/${sectionId}/seats/${seatId}`, data),

  deleteSeat: (eventId, sectionId, seatId) =>
    api.delete(`/organizer/events/${eventId}/seat-map/sections/${sectionId}/seats/${seatId}`),

  batchSeats: (eventId, payload) =>
    api.post(`/organizer/events/${eventId}/seat-map/seats/batch`, payload),

  // ── Price zones ───────────────────────────────────────────────────────────
  getPriceZones: (eventId) =>
    api.get(`/organizer/events/${eventId}/seat-map/price-zones`),

  createPriceZone: (eventId, data) =>
    api.post(`/organizer/events/${eventId}/seat-map/price-zones`, data),

  updatePriceZone: (eventId, zoneId, data) =>
    api.put(`/organizer/events/${eventId}/seat-map/price-zones/${zoneId}`, data),

  deletePriceZone: (eventId, zoneId) =>
    api.delete(`/organizer/events/${eventId}/seat-map/price-zones/${zoneId}`),
};

export default seatMapService;
